import { Column } from "@/components/Column";
import { ErrorText } from "@/components/ErrorText";
import { Row } from "@/components/Row";
import { Skeleton } from "@/components/ui/skeleton";

import { EarningsProgressBar } from "./EarningsProgressBar";
import { EarningsTotalsSnapshot } from "./EarningsTotalsSnapshot";

import { useGetStafferEarnings } from "@/hooks/queries/useGetStafferEarnings";

export const EarningsChartSection = ({
  selectedUserId,
}: {
  selectedUserId?: number;
}) => {
  /* Database CRUD Operations */
  // Read
  const {
    data: earnings,
    isPending,
    isError,
  } = useGetStafferEarnings({ userId: selectedUserId });

  /* Render */
  const renderSkeleton = () => (
    <Column className="gap-5">
      <Row className="items-start gap-8 pb-3">
        <Column className="gap-2 pr-6">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-7 w-32" />
        </Column>
        <Column className="gap-2 pr-6">
          <Skeleton className="h-3 w-28" />
          <Skeleton className="h-7 w-32" />
        </Column>
      </Row>
      <Column className="gap-4 pb-5">
        <Skeleton className="h-4 w-full rounded-full" />
        <Row className="gap-8">
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-20" />
        </Row>
      </Column>
    </Column>
  );

  const render = () => {
    if (isPending) {
      return renderSkeleton();
    }

    if (isError) {
      return <ErrorText errorMessage="Failed to load earnings." />;
    }

    return (
      <Column className="gap-5">
        <EarningsTotalsSnapshot
          totalCommissionDollars={earnings.totalCommissionYtd}
          totalRevenueDollars={earnings.totalRevenueYtd}
        />
        <Column className="pb-5">
          <EarningsProgressBar
            tiers={earnings.commissionTiers}
            totalRevenueDollars={earnings.totalRevenueYtd}
          />
        </Column>
      </Column>
    );
  };

  return render();
};
